import { render, staticRenderFns } from "./ai_detector_form.vue?vue&type=template&id=1f5cfe9e&"
import script from "./ai_detector_form.vue?vue&type=script&lang=js&"
export * from "./ai_detector_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports